import React from "react";
import {
  Row,
  Col,
  Typography,
  Input,
  Card,
  Image,
  Spin,
  Divider,
  Space,
} from "antd";
import moment from "moment";
const { Title, Text } = Typography;

export default function Queries({ data, loading }) {
  console.log("data quesries", data);
  return (
    <>
      <Spin size="large" spinning={loading}>
        {data.map((item, index) => (
          <span key={index}>
            <Row>
              {index !== 0 && <Divider style={{ margin: "1em" }} />}
              <Col span={24}>
                {<br />}
                <Title level={5}>Query ID {item?.id}</Title>
              </Col>
            </Row>
            <Row>
              <Col>
                <Text type="secondary">
                  Sent by {item?.buyer_email} on{" "}
                  {moment(item.date_created).format("Do MMM' YY")}
                </Text>
              </Col>
            </Row>

            <Row style={{ marginTop: "2em" }}>
              <Col span={24}>
                <Text>Message from Buyer</Text>
                <Input.TextArea value={item?.comment} rows={4} disabled />
              </Col>
            </Row>

            <Row style={{ marginTop: "2.5em" }}>
              <Col>
                <Text>Shortlisted products</Text>
              </Col>
            </Row>

            {item?.products.map((product, index) => (
              <Row key={index}>
                <Col span={10}>
                  {console.log("product:", product)}
                  <Card
                    className="product-card-analytics"
                    cover={
                      <Image
                        // src={`${process.env.REACT_APP_CLOUDINARY}/b_rgb:f2f2f2,c_pad,h_140,q_70,w_177/${product?.collections_products_id?.products_id?.product_images?.[0]?.directus_files_id}`}
                        src={`${process.env.REACT_APP_DIRECTUS}assets/${product?.collections_products_id?.products_id?.product_images?.[0]?.directus_files_id}?transforms=[["resize",{"width":177,"height":140,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`}
                        alt={"product name"}
                        preview={false}
                      />
                    }
                  >
                    <Row>
                      <Title className="product-id" type="secondary" level={5}>
                        ID :{" "}
                        {product?.collections_products_id?.products_id
                          ?.product_id
                          ? product?.collections_products_id?.products_id
                              ?.product_id
                          : "No product id"}
                      </Title>
                    </Row>
                  </Card>
                </Col>

                <Col push={2} span={12} style={{ marginTop: "1.3em" }}>
                  <Input.TextArea disabled value={product?.comment} rows={9} />
                </Col>
              </Row>
            ))}
          </span>
        ))}
      </Spin>
    </>
  );
}
